import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { getAvailableSeatTypes } from 'lib/seats/seatTypes';
import KeyIcon from './KeyIcon';

const SeatKey = props => {
  const seatTypes = getAvailableSeatTypes();
  const customIconSize = get(props.currentFacility, 'customIconSize', 10);
  return (
    <div className="syos-key">
      <ul className="syos-key__list">
        {seatTypes.map(function(type, idx) {
          return (
            <li className="syos-key__list__item" key={idx}>
              <span className="syos-key__icon">
                <KeyIcon seatType={type} customIconSize={customIconSize} />
              </span>
              <span className="syos-key__label">{type.label}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
SeatKey.propTypes = {
  currentFacility: PropTypes.object
};

export default SeatKey;



// WEBPACK FOOTER //
// ./src/javascripts/components/SeatKey.js